import Chart from "artifact/chart";
import supabase from "artifact/supabase";
import { Tooltip } from "chart.js";
import { callback } from "chart.js/dist/helpers/helpers.core";
import connected from "standard/connected";
import define from "standard/define";
import didPaint from "standard/didPaint";
import paint from "standard/paint";
import trait from "standard/trait";
import willPaint from "standard/willPaint";
import style from "./style";

@define("m-student-performance-hard")
class Hard extends HTMLElement {
  #activity;
  #criterions;
  #presence;

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  get [trait.presence]() {
    return (this.#presence ??= this.shadowRoot.getElementById("skill"));
  }

  @willPaint
  async [trait.fetch]() {
    const { data } = await supabase
      .from("activity_corrected")
      .select(
        "*, activity_criterion!inner(*, criterion!inner(titulo, criterion_type!inner(id)), criterion_level!inner(*), activity!inner(id, video!inner(id, academy!inner(id, level_of_education!inner(id, grade!inner(school_id))))))",
      )
      .eq(
        "activity_criterion.activity.video.academy.level_of_education.grade.school_id",
        this.dataset.school,
      )
      .eq(
        "activity_criterion.criterion.criterion_type.id",
        "7fc3ff56-2ab1-4eb7-b0fb-960ffcc3fa97",
      );

    this.#criterions = data.group((d) => d.activity_criterion.criterion.titulo);
    return this;
  }

  @connected
  @paint
  [trait.template]() {
    return `
      <section class=${style.performance}>
        <canvas id="skill" />
      </section>
    `;
  }

  @didPaint
  [trait.chat]() {
    // const labels = Object.keys(this.#criterions);
    const labels = [
      "Mecatrônica",
      "Língua inglesa",
      "Gestão de projetos",
      "Programação",
      "Design",
    ];
    const data = labels.map(
      (key) =>
        Math.trunc(
          this.#criterions[key]
            ?.map((c) => c.answer * c.activity_criterion.criterion_level.value)
            ?.reduce((x, y) => x + y) / (this.#criterions[key]?.length || 0),
        ) || 1,
    );

    const user = labels.map(
      (key) =>
        Math.trunc(
          this.#criterions[key]
            ?.filter((c) => c.student_id === this.dataset.user)
            ?.map((c) => c.answer * c.activity_criterion.criterion_level.value)
            ?.reduce((x, y) => x + y, 0) / (this.#criterions[key]?.length || 0),
        ) || 1,
    );

    const _chart = new Chart(this[trait.presence], {
      type: "radar",
      data: {
        labels,
        datasets: [
          {
            label: "Média da turma",
            text: "Média da turma",
            backgroundColor: "rgba(255, 194, 60, 0.2)",
            borderColor: "#013660",
            data: data,
            pointBorderColor: "#013660",
            pointBorderWidth: "10",
          },
          {
            label: "Média do Aluno",
            backgroundColor: "rgba(41, 128, 185, 0.2)",
            borderColor: "#013660",
            data: user,
            pointBorderColor: "#013660",
            pointBorderWidth: "10",
          },
          // {
          //   backgroundColor: "rgba(42, 179, 136, 0.2)",
          //   borderColor: "#013660",
          //   data: [3, 1, 2, 1, 3],
          //   pointBorderColor: "#013660",
          //   pointBorderWidth: "10",
          // },
          {
            backgroundColor: "transparent",
            borderColor: "transparent",
            data: Array(labels.length).fill(0),
            pointBorderColor: "transparent",
          },
          {
            backgroundColor: "transparent",
            borderColor: "transparent",
            data: Array(labels.length).fill(1),
            pointBorderColor: "#1a1a1a",
          },
          {
            backgroundColor: "transparent",
            borderColor: "transparent",
            data: Array(labels.length).fill(2),
            pointBorderColor: "#1a1a1a",
          },
          {
            backgroundColor: "transparent",
            borderColor: "transparent",
            data: Array(labels.length).fill(3),
            pointBorderColor: "#1a1a1a",
          },
        ],
      },
      options: {
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            callbacks: {
              label: (tooltipItem) => {
                if (tooltipItem.formattedValue === "0") {
                  return "";
                }

                if (tooltipItem.dataset.label === "Média do Aluno") {
                  if (tooltipItem.formattedValue === "1") {
                    return "Aluno Abaixo da média esperada";
                  }

                  if (tooltipItem.formattedValue === "2") {
                    return "Aluno Dentro da média esperada";
                  }

                  if (tooltipItem.formattedValue === "3") {
                    return "Aluno Acima da média esperada";
                  }
                }

                if (tooltipItem.dataset.label === "Média da turma") {
                  if (tooltipItem.formattedValue === "1") {
                    return "Turma Abaixo da média esperada";
                  }

                  if (tooltipItem.formattedValue === "2") {
                    return "Turma Dentro da média esperada";
                  }

                  if (tooltipItem.formattedValue === "3") {
                    return "Turma Acima da média esperada";
                  }
                }
              },
            },
          },
        },
        scale: {
          ticks: {
            beginAtZero: false,
            stepSize: 1,
          },
        },
        scales: {
          r: {
            angleLines: {
              color: "transparent",
            },
            pointLabels: {
              color: "#1a1a1a",
              font: {
                family: "'Roboto', sans-serif",
                size: 11,
                weight: 400,
              },
            },
            ticks: {
              color: "transparent",
            },
          },
        },
      },
    });
    return this;
  }
}

export default Hard;
